import { produce } from "immer";
import {
    TODAYS_RESERVATION_OVERVIEW_REQUEST,
    TODAYS_RESERVATION_OVERVIEW_SUCCESS,
    TODAYS_RESERVATION_OVERVIEW_FAILURE,

    TODAYS_RESERVATION_VOLUME_BY_SESSION_REQUEST,
    TODAYS_RESERVATION_VOLUME_BY_SESSION_SUCCESS,
    TODAYS_RESERVATION_VOLUME_BY_SESSION_FAILURE,

    TODAYS_ASSIGNED_RESERVATION_REQUEST,
    TODAYS_ASSIGNED_RESERVATION_SUCCESS,
    TODAYS_ASSIGNED_RESERVATION_FAILURE,

    TODAYS_UPCOMING_RESERVATION_REQUEST,
    TODAYS_UPCOMING_RESERVATION_SUCCESS,
    TODAYS_UPCOMING_RESERVATION_FAILURE,

    UPCOMING_RESERVATION_OVERVIEW_REQUEST,
    UPCOMING_RESERVATION_OVERVIEW_SUCCESS,
    UPCOMING_RESERVATION_OVERVIEW_FAILURE,

    UPCOMING_RESERVATION_VOLUME_BY_SESSION_REQUEST,
    UPCOMING_RESERVATION_VOLUME_BY_SESSION_SUCCESS,
    UPCOMING_RESERVATION_VOLUME_BY_SESSION_FAILURE,

    UPCOMING_RESERVATION_VOLUME_REQUEST,
    UPCOMING_RESERVATION_VOLUME_SUCCESS,
    UPCOMING_RESERVATION_VOLUME_FAILURE,

    UPCOMING_RESERVATION_BY_SESSION_REQUEST,
    UPCOMING_RESERVATION_BY_SESSION_SUCCESS,
    UPCOMING_RESERVATION_BY_SESSION_FAILURE,

    UPCOMING_RESERVATION_STATUS_BY_DATE_REQUEST,
    UPCOMING_RESERVATION_STATUS_BY_DATE_SUCCESS,
    UPCOMING_RESERVATION_STATUS_BY_DATE_FAILURE,

    UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_REQUEST,
    UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_SUCCESS,
    UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_FAILURE,

    UPCOMING_RESERVATION_DETAILS_REQUEST,
    UPCOMING_RESERVATION_DETAILS_SUCCESS,
    UPCOMING_RESERVATION_DETAILS_FAILURE,

    RESERVATION_OVERVIEW_REQUEST,
    RESERVATION_OVERVIEW_SUCCESS,
    RESERVATION_OVERVIEW_FAILURE,

    RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_REQUEST,
    RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_SUCCESS,
    RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_FAILURE,

    RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_REQUEST,
    RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_SUCCESS,
    RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_FAILURE,

    RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_REQUEST,
    RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_SUCCESS,
    RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_FAILURE,

    RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_REQUEST,
    RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_SUCCESS,
    RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_FAILURE,

    RESERVATION_OVERVIEW_DETAILS_REQUEST,
    RESERVATION_OVERVIEW_DETAILS_SUCCESS,
    RESERVATION_OVERVIEW_DETAILS_FAILURE,

    RESERVATION_TREND_OVERVIEW_REQUEST,
    RESERVATION_TREND_OVERVIEW_SUCCESS,
    RESERVATION_TREND_OVERVIEW_FAILURE,

    RESERVATION_TREND_REQUEST,
    RESERVATION_TREND_SUCCESS,
    RESERVATION_TREND_FAILURE,

    RESERVATION_TREND_BY_GROUPS_REQUEST,
    RESERVATION_TREND_BY_GROUPS_SUCCESS,
    RESERVATION_TREND_BY_GROUPS_FAILURE,

    RESERVATION_TREND_BY_AVG_WAIT_TIME_REQUEST,
    RESERVATION_TREND_BY_AVG_WAIT_TIME_SUCCESS,
    RESERVATION_TREND_BY_AVG_WAIT_TIME_FAILURE,

    RESERVATION_TREND_CUSTOMER_TREND_REQUEST,
    RESERVATION_TREND_CUSTOMER_TREND_SUCCESS,
    RESERVATION_TREND_CUSTOMER_TREND_FAILURE,

    RESERVATION_TREND_CUSTOMER_VISITS_REQUEST,
    RESERVATION_TREND_CUSTOMER_VISITS_SUCCESS,
    RESERVATION_TREND_CUSTOMER_VISITS_FAILURE,

    UPCOMING_RESERVATION_START_DATE_CHANGE,
    UPCOMING_RESERVATION_END_DATE_CHANGE
} from "./reservationReportsConstants";

const initialState = {
    todaysReservationOverviewLoading: false,
    todaysReservationOverviewData: [],
    todaysReservationOverviewError: false,

    todaysReservationVolumeBySessionLoading: false,
    todaysReservationVolumeBySessionData: [],
    todaysReservationVolumeBySessionError: false,

    todaysAssignedReservationLoading: false,
    todaysAssignedReservationData: [],
    todaysAssignedReservationError: false,

    todaysUpcomingReservationLoading: false,
    todaysUpcomingReservationData: [],
    todaysUpcomingReservationError: false,

    upcomingReservationOverviewLoading: false,
    upcomingReservationOverviewData: [],
    upcomingReservationOverviewError: false,

    upcomingReservationVolumeBySessionLoading: false,
    upcomingReservationVolumeBySessionData: [],
    upcomingReservationVolumeBySessionError: false,

    upcomingReservationVolumeLoading: false,
    upcomingReservationVolumeData: [],
    upcomingReservationVolumeError: false,

    upcomingReservationBySessionLoading: false,
    upcomingReservationBySessionData: [],
    upcomingReservationBySessionError: false,

    upcomingReservationStatusByDateLoading: false,
    upcomingReservationStatusByDateData: [],
    upcomingReservationStatusByDateError: false,

    upcomingReservationCancellationByReasonsLoading: false,
    upcomingReservationCancellationByReasonsData: [],
    upcomingReservationCancellationByReasonsError: false,

    upcomingReservationDetailsLoading: false,
    upcomingReservationDetailsData: [],
    upcomingReservationDetailsError: false,

    reservationOverviewLoading: false,
    reservationOverviewData: [],
    reservationOverviewError: false,

    reservationOverviewSlotWiseReservationLoading: false,
    reservationOverviewSlotWiseReservationData: [],
    reservationOverviewSlotWiseReservationError: false,

    reservationOverviewDailyReservationsGuestsLoading: false,
    reservationOverviewDailyReservationsGuestsData: [],
    reservationOverviewDailyReservationsGuestsError: false,

    reservationOverviewDineInDurationByGroupsLoading: false,
    reservationOverviewDineInDurationByGroupsData: [],
    reservationOverviewDineInDurationByGroupsError: false,

    reservationOverviewGuestSizeDistributionLoading: false,
    reservationOverviewGuestSizeDistributionData: [],
    reservationOverviewGuestSizeDistributionError: false,

    reservationOverviewDetailsLoading: false,
    reservationOverviewDetailsData: [],
    reservationOverviewDetailsError: false,

    reservationTrendOverviewLoading: false,
    reservationTrendOverviewData: [],
    reservationTrendOverviewError: false,

    reservationTrendLoading: false,
    reservationTrendData: [],
    reservationTrendError: false,

    reservationTrendByGroupsLoading: false,
    reservationTrendByGroupsData: [],
    reservationTrendByGroupsError: false,

    reservationTrendByAvgWaitTimeLoading: false,
    reservationTrendByAvgWaitTimeData: [],
    reservationTrendByAvgWaitTimeError: false,

    reservationTrendCustomerTrendLoading: false,
    reservationTrendCustomerTrendData: [],
    reservationTrendCustomerTrendError: false,

    reservationTrendCustomerVisitsLoading: false,
    reservationTrendCustomerVisitsData: [],
    reservationTrendCustomerVisitsError: false,

    upcomingReservationStartDate: null,
    upcomingReservationEndDate: null,
};



export default function reservationReportsReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case TODAYS_RESERVATION_OVERVIEW_REQUEST:
                draft.todaysReservationOverviewLoading = true;
                draft.todaysReservationOverviewData = [];
                draft.todaysReservationOverviewError = false;
                break;
            case TODAYS_RESERVATION_OVERVIEW_SUCCESS:
                draft.todaysReservationOverviewLoading = false;
                draft.todaysReservationOverviewData = action.payload;
                draft.todaysReservationOverviewError = false;
                break;
            case TODAYS_RESERVATION_OVERVIEW_FAILURE:
                draft.todaysReservationOverviewLoading = false;
                draft.todaysReservationOverviewData = [];
                draft.todaysReservationOverviewError = true;
                break;

            case TODAYS_RESERVATION_VOLUME_BY_SESSION_REQUEST:
                draft.todaysReservationVolumeBySessionLoading = true;
                draft.todaysReservationVolumeBySessionData = [];
                draft.todaysReservationVolumeBySessionError = false;
                break;
            case TODAYS_RESERVATION_VOLUME_BY_SESSION_SUCCESS:
                draft.todaysReservationVolumeBySessionLoading = false;
                draft.todaysReservationVolumeBySessionData = action.payload;
                draft.todaysReservationVolumeBySessionError = false;
                break;
            case TODAYS_RESERVATION_VOLUME_BY_SESSION_FAILURE:
                draft.todaysReservationVolumeBySessionLoading = false;
                draft.todaysReservationVolumeBySessionData = [];
                draft.todaysReservationVolumeBySessionError = true;
                break;

            case TODAYS_ASSIGNED_RESERVATION_REQUEST:
                draft.todaysAssignedReservationLoading = true;
                draft.todaysAssignedReservationData = [];
                draft.todaysAssignedReservationError = false;
                break;
            case TODAYS_ASSIGNED_RESERVATION_SUCCESS:
                draft.todaysAssignedReservationLoading = false;
                draft.todaysAssignedReservationData = action.payload;
                draft.todaysAssignedReservationError = false;
                break;
            case TODAYS_ASSIGNED_RESERVATION_FAILURE:
                draft.todaysAssignedReservationLoading = false;
                draft.todaysAssignedReservationData = [];
                draft.todaysAssignedReservationError = true;
                break;

            case TODAYS_UPCOMING_RESERVATION_REQUEST:
                draft.todaysUpcomingReservationLoading = true;
                draft.todaysUpcomingReservationData = [];
                draft.todaysUpcomingReservationError = false;
                break;
            case TODAYS_UPCOMING_RESERVATION_SUCCESS:
                draft.todaysUpcomingReservationLoading = false;
                draft.todaysUpcomingReservationData = action.payload;
                draft.todaysUpcomingReservationError = false;
                break;
            case TODAYS_UPCOMING_RESERVATION_FAILURE:
                draft.todaysUpcomingReservationLoading = false;
                draft.todaysUpcomingReservationData = [];
                draft.todaysUpcomingReservationError = true;
                break;
            case UPCOMING_RESERVATION_OVERVIEW_REQUEST:
                draft.upcomingReservationOverviewLoading = true;
                draft.upcomingReservationOverviewData = [];
                draft.upcomingReservationOverviewError = false;
                break;
            case UPCOMING_RESERVATION_OVERVIEW_SUCCESS:
                draft.upcomingReservationOverviewLoading = false;
                draft.upcomingReservationOverviewData = action.payload;
                draft.upcomingReservationOverviewError = false;
                break;
            case UPCOMING_RESERVATION_OVERVIEW_FAILURE:
                draft.upcomingReservationOverviewLoading = false;
                draft.upcomingReservationOverviewData = [];
                draft.upcomingReservationOverviewError = true;
                break;

            // UPCOMING_RESERVATION_VOLUME_BY_SESSION
            case UPCOMING_RESERVATION_VOLUME_BY_SESSION_REQUEST:
                draft.upcomingReservationVolumeBySessionLoading = true;
                draft.upcomingReservationVolumeBySessionData = [];
                draft.upcomingReservationVolumeBySessionError = false;
                break;
            case UPCOMING_RESERVATION_VOLUME_BY_SESSION_SUCCESS:
                draft.upcomingReservationVolumeBySessionLoading = false;
                draft.upcomingReservationVolumeBySessionData = action.payload;
                draft.upcomingReservationVolumeBySessionError = false;
                break;
            case UPCOMING_RESERVATION_VOLUME_BY_SESSION_FAILURE:
                draft.upcomingReservationVolumeBySessionLoading = false;
                draft.upcomingReservationVolumeBySessionData = [];
                draft.upcomingReservationVolumeBySessionError = true;
                break;

            // UPCOMING_RESERVATION_VOLUME
            case UPCOMING_RESERVATION_VOLUME_REQUEST:
                draft.upcomingReservationVolumeLoading = true;
                draft.upcomingReservationVolumeData = [];
                draft.upcomingReservationVolumeError = false;
                break;
            case UPCOMING_RESERVATION_VOLUME_SUCCESS:
                draft.upcomingReservationVolumeLoading = false;
                draft.upcomingReservationVolumeData = action.payload;
                draft.upcomingReservationVolumeError = false;
                break;
            case UPCOMING_RESERVATION_VOLUME_FAILURE:
                draft.upcomingReservationVolumeLoading = false;
                draft.upcomingReservationVolumeData = [];
                draft.upcomingReservationVolumeError = true;
                break;

            // UPCOMING_RESERVATION_BY_SESSION
            case UPCOMING_RESERVATION_BY_SESSION_REQUEST:
                draft.upcomingReservationBySessionLoading = true;
                draft.upcomingReservationBySessionData = [];
                draft.upcomingReservationBySessionError = false;
                break;
            case UPCOMING_RESERVATION_BY_SESSION_SUCCESS:
                draft.upcomingReservationBySessionLoading = false;
                draft.upcomingReservationBySessionData = action.payload;
                draft.upcomingReservationBySessionError = false;
                break;
            case UPCOMING_RESERVATION_BY_SESSION_FAILURE:
                draft.upcomingReservationBySessionLoading = false;
                draft.upcomingReservationBySessionData = [];
                draft.upcomingReservationBySessionError = true;
                break;

            // UPCOMING_RESERVATION_STATUS_BY_DATE
            case UPCOMING_RESERVATION_STATUS_BY_DATE_REQUEST:
                draft.upcomingReservationStatusByDateLoading = true;
                draft.upcomingReservationStatusByDateData = [];
                draft.upcomingReservationStatusByDateError = false;
                break;
            case UPCOMING_RESERVATION_STATUS_BY_DATE_SUCCESS:
                draft.upcomingReservationStatusByDateLoading = false;
                draft.upcomingReservationStatusByDateData = action.payload;
                draft.upcomingReservationStatusByDateError = false;
                break;
            case UPCOMING_RESERVATION_STATUS_BY_DATE_FAILURE:
                draft.upcomingReservationStatusByDateLoading = false;
                draft.upcomingReservationStatusByDateData = [];
                draft.upcomingReservationStatusByDateError = true;
                break;

            // UPCOMING_RESERVATION_CANCELLATION_BY_REASONS
            case UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_REQUEST:
                draft.upcomingReservationCancellationByReasonsLoading = true;
                draft.upcomingReservationCancellationByReasonsData = [];
                draft.upcomingReservationCancellationByReasonsError = false;
                break;
            case UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_SUCCESS:
                draft.upcomingReservationCancellationByReasonsLoading = false;
                draft.upcomingReservationCancellationByReasonsData = action.payload;
                draft.upcomingReservationCancellationByReasonsError = false;
                break;
            case UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_FAILURE:
                draft.upcomingReservationCancellationByReasonsLoading = false;
                draft.upcomingReservationCancellationByReasonsData = [];
                draft.upcomingReservationCancellationByReasonsError = true;
                break;

            // UPCOMING_RESERVATION_DETAILS
            case UPCOMING_RESERVATION_DETAILS_REQUEST:
                draft.upcomingReservationDetailsLoading = true;
                draft.upcomingReservationDetailsData = [];
                draft.upcomingReservationDetailsError = false;
                break;
            case UPCOMING_RESERVATION_DETAILS_SUCCESS:
                draft.upcomingReservationDetailsLoading = false;
                draft.upcomingReservationDetailsData = action.payload;
                draft.upcomingReservationDetailsError = false;
                break;
            case UPCOMING_RESERVATION_DETAILS_FAILURE:
                draft.upcomingReservationDetailsLoading = false;
                draft.upcomingReservationDetailsData = [];
                draft.upcomingReservationDetailsError = true;
                break
            case RESERVATION_OVERVIEW_REQUEST:
                draft.reservationOverviewLoading = true;
                draft.reservationOverviewData = [];
                draft.reservationOverviewError = false;
                break;
            case RESERVATION_OVERVIEW_SUCCESS:
                draft.reservationOverviewLoading = false;
                draft.reservationOverviewData = action.payload;
                draft.reservationOverviewError = false;
                break;
            case RESERVATION_OVERVIEW_FAILURE:
                draft.reservationOverviewLoading = false;
                draft.reservationOverviewData = [];
                draft.reservationOverviewError = true;
                break;

            // RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION
            case RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_REQUEST:
                draft.reservationOverviewSlotWiseReservationLoading = true;
                draft.reservationOverviewSlotWiseReservationData = [];
                draft.reservationOverviewSlotWiseReservationError = false;
                break;
            case RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_SUCCESS:
                draft.reservationOverviewSlotWiseReservationLoading = false;
                draft.reservationOverviewSlotWiseReservationData = action.payload;
                draft.reservationOverviewSlotWiseReservationError = false;
                break;
            case RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_FAILURE:
                draft.reservationOverviewSlotWiseReservationLoading = false;
                draft.reservationOverviewSlotWiseReservationData = [];
                draft.reservationOverviewSlotWiseReservationError = true;
                break;

            // RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS
            case RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_REQUEST:
                draft.reservationOverviewDailyReservationsGuestsLoading = true;
                draft.reservationOverviewDailyReservationsGuestsData = [];
                draft.reservationOverviewDailyReservationsGuestsError = false;
                break;
            case RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_SUCCESS:
                draft.reservationOverviewDailyReservationsGuestsLoading = false;
                draft.reservationOverviewDailyReservationsGuestsData = action.payload;
                draft.reservationOverviewDailyReservationsGuestsError = false;
                break;
            case RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_FAILURE:
                draft.reservationOverviewDailyReservationsGuestsLoading = false;
                draft.reservationOverviewDailyReservationsGuestsData = [];
                draft.reservationOverviewDailyReservationsGuestsError = true;
                break;

            // RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS
            case RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_REQUEST:
                draft.reservationOverviewDineInDurationByGroupsLoading = true;
                draft.reservationOverviewDineInDurationByGroupsData = [];
                draft.reservationOverviewDineInDurationByGroupsError = false;
                break;
            case RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_SUCCESS:
                draft.reservationOverviewDineInDurationByGroupsLoading = false;
                draft.reservationOverviewDineInDurationByGroupsData = action.payload;
                draft.reservationOverviewDineInDurationByGroupsError = false;
                break;
            case RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_FAILURE:
                draft.reservationOverviewDineInDurationByGroupsLoading = false;
                draft.reservationOverviewDineInDurationByGroupsData = [];
                draft.reservationOverviewDineInDurationByGroupsError = true;
                break;

            // RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION
            case RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_REQUEST:
                draft.reservationOverviewGuestSizeDistributionLoading = true;
                draft.reservationOverviewGuestSizeDistributionData = [];
                draft.reservationOverviewGuestSizeDistributionError = false;
                break;
            case RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_SUCCESS:
                draft.reservationOverviewGuestSizeDistributionLoading = false;
                draft.reservationOverviewGuestSizeDistributionData = action.payload;
                draft.reservationOverviewGuestSizeDistributionError = false;
                break;
            case RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_FAILURE:
                draft.reservationOverviewGuestSizeDistributionLoading = false;
                draft.reservationOverviewGuestSizeDistributionData = [];
                draft.reservationOverviewGuestSizeDistributionError = true;
                break;

            // RESERVATION_OVERVIEW_DETAILS
            case RESERVATION_OVERVIEW_DETAILS_REQUEST:
                draft.reservationOverviewDetailsLoading = true;
                draft.reservationOverviewDetailsData = [];
                draft.reservationOverviewDetailsError = false;
                break;
            case RESERVATION_OVERVIEW_DETAILS_SUCCESS:
                draft.reservationOverviewDetailsLoading = false;
                draft.reservationOverviewDetailsData = action.payload;
                draft.reservationOverviewDetailsError = false;
                break;
            case RESERVATION_OVERVIEW_DETAILS_FAILURE:
                draft.reservationOverviewDetailsLoading = false;
                draft.reservationOverviewDetailsData = [];
                draft.reservationOverviewDetailsError = true;
                break;
            case RESERVATION_TREND_OVERVIEW_REQUEST:
                draft.reservationTrendOverviewLoading = true;
                draft.reservationTrendOverviewData = [];
                draft.reservationTrendOverviewError = false;
                break;
            case RESERVATION_TREND_OVERVIEW_SUCCESS:
                draft.reservationTrendOverviewLoading = false;
                draft.reservationTrendOverviewData = action.payload;
                draft.reservationTrendOverviewError = false;
                break;
            case RESERVATION_TREND_OVERVIEW_FAILURE:
                draft.reservationTrendOverviewLoading = false;
                draft.reservationTrendOverviewData = [];
                draft.reservationTrendOverviewError = true;
                break;

            // RESERVATION_TREND
            case RESERVATION_TREND_REQUEST:
                draft.reservationTrendLoading = true;
                draft.reservationTrendData = [];
                draft.reservationTrendError = false;
                break;
            case RESERVATION_TREND_SUCCESS:
                draft.reservationTrendLoading = false;
                draft.reservationTrendData = action.payload;
                draft.reservationTrendError = false;
                break;
            case RESERVATION_TREND_FAILURE:
                draft.reservationTrendLoading = false;
                draft.reservationTrendData = [];
                draft.reservationTrendError = true;
                break;

            // RESERVATION_TREND_BY_GROUPS
            case RESERVATION_TREND_BY_GROUPS_REQUEST:
                draft.reservationTrendByGroupsLoading = true;
                draft.reservationTrendByGroupsData = [];
                draft.reservationTrendByGroupsError = false;
                break;
            case RESERVATION_TREND_BY_GROUPS_SUCCESS:
                draft.reservationTrendByGroupsLoading = false;
                draft.reservationTrendByGroupsData = action.payload;
                draft.reservationTrendByGroupsError = false;
                break;
            case RESERVATION_TREND_BY_GROUPS_FAILURE:
                draft.reservationTrendByGroupsLoading = false;
                draft.reservationTrendByGroupsData = [];
                draft.reservationTrendByGroupsError = true;
                break;

            // RESERVATION_TREND_BY_AVG_WAIT_TIME
            case RESERVATION_TREND_BY_AVG_WAIT_TIME_REQUEST:
                draft.reservationTrendByAvgWaitTimeLoading = true;
                draft.reservationTrendByAvgWaitTimeData = [];
                draft.reservationTrendByAvgWaitTimeError = false;
                break;
            case RESERVATION_TREND_BY_AVG_WAIT_TIME_SUCCESS:
                draft.reservationTrendByAvgWaitTimeLoading = false;
                draft.reservationTrendByAvgWaitTimeData = action.payload;
                draft.reservationTrendByAvgWaitTimeError = false;
                break;
            case RESERVATION_TREND_BY_AVG_WAIT_TIME_FAILURE:
                draft.reservationTrendByAvgWaitTimeLoading = false;
                draft.reservationTrendByAvgWaitTimeData = [];
                draft.reservationTrendByAvgWaitTimeError = true;
                break;

            // RESERVATION_TREND_CUSTOMER_TREND
            case RESERVATION_TREND_CUSTOMER_TREND_REQUEST:
                draft.reservationTrendCustomerTrendLoading = true;
                draft.reservationTrendCustomerTrendData = [];
                draft.reservationTrendCustomerTrendError = false;
                break;
            case RESERVATION_TREND_CUSTOMER_TREND_SUCCESS:
                draft.reservationTrendCustomerTrendLoading = false;
                draft.reservationTrendCustomerTrendData = action.payload;
                draft.reservationTrendCustomerTrendError = false;
                break;
            case RESERVATION_TREND_CUSTOMER_TREND_FAILURE:
                draft.reservationTrendCustomerTrendLoading = false;
                draft.reservationTrendCustomerTrendData = [];
                draft.reservationTrendCustomerTrendError = true;
                break;

            // RESERVATION_TREND_CUSTOMER_VISITS
            case RESERVATION_TREND_CUSTOMER_VISITS_REQUEST:
                draft.reservationTrendCustomerVisitsLoading = true;
                draft.reservationTrendCustomerVisitsData = [];
                draft.reservationTrendCustomerVisitsError = false;
                break;
            case RESERVATION_TREND_CUSTOMER_VISITS_SUCCESS:
                draft.reservationTrendCustomerVisitsLoading = false;
                draft.reservationTrendCustomerVisitsData = action.payload;
                draft.reservationTrendCustomerVisitsError = false;
                break;
            case RESERVATION_TREND_CUSTOMER_VISITS_FAILURE:
                draft.reservationTrendCustomerVisitsLoading = false;
                draft.reservationTrendCustomerVisitsData = [];
                draft.reservationTrendCustomerVisitsError = true;
                break;

            case UPCOMING_RESERVATION_START_DATE_CHANGE:
                draft.upcomingReservationStartDate = action.payload;

            case UPCOMING_RESERVATION_END_DATE_CHANGE:
                draft.upcomingReservationEndDate = action.payload;
                
            default:
                break;
        }
    })
}